import React from "react";
import "./title-box-header.scss";

export default ({ title }) => {
    return (
        <div className={'title-box-header'} >{title}</div>
    );
};
